import httpClient from '../httpClient';

export default {
  getKey () {
    return httpClient('v0.4').get('/stripe_key');
  }
}
